<template>
  <div>
    <draggable v-model="members" :options="{ handle: '.ion-drag' }">
      <TeamFormMember
        v-for="(member, index) in members"
        :key="index"
        :index="index"
        :member="member"
        :errors="memberErrors[index] || {}"
      />
    </draggable>

    <div class="actions">
      <button class="btn btn-primary" @click="addMemberSlot()">
        <i class="ion ion-plus-round"></i>
        Add member
      </button>
      <button class="btn btn-primary" @click="save()">
        Save
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '../../services/notifications'
import TeamFormMember from './TeamFormMember.vue'
import draggable from 'vuedraggable'

export default {
  components: { draggable, TeamFormMember },
  computed: {
    members: {
      get() {
        return this.$store.state.startupProfile.startup.members
      },
      set(members) {
        this.$store.commit('startupProfile/SET_STARTUP_ATTR', {
          attr: 'members',
          value: members,
        })
      },
    },
    ...mapState('startupProfile', ['errors']),
    memberErrors() {
      return this.errors.members || []
    },
  },
  methods: {
    addMemberSlot() {
      this.$store.commit('startupProfile/ADD_MEMBER_SLOT')
    },
    async save() {
      try {
        await this.$store.dispatch('startupProfile/saveChanges', {
          fields: ['members'],
        })
      } catch (error) {
        notifications.notify({ title: 'Something went wrong', type: 'danger' })
        return
      }
      notifications.notify({ title: 'Team saved', type: 'success' })
    },
  },
}
</script>
